// extracted by mini-css-extract-plugin
export default {"content":"MagicMath_content__+5vC7"};